import classNames from "classnames";
import React from "react";

import css from "./card.module.scss";

type CardProps = {
  children: React.ReactNode;
  qaId?: string;
  shadowVariant?: "none" | "default";
  paddingVariant?: "none" | "lg" | "xl";
  className?: string;
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, qaId = "Card", shadowVariant = "default", paddingVariant = "lg", className }, ref) => (
    <div
      ref={ref}
      data-qa-id={qaId}
      className={classNames(css.card, className, {
        [css.noPadding]: paddingVariant === "none",
        [css.largePadding]: paddingVariant === "lg",
        [css.xlargePadding]: paddingVariant === "xl",
        [css.shadowNone]: shadowVariant === "none"
      })}
    >
      {children}
    </div>
  )
);

Card.displayName = "Card";
